/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BoostTier3SimpleIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABhElEQVR4nOWVsUoDQRCGrxC1MIoiYqlY+wxneZjszEQZdi4KqWIEH8D3sNN3UHwCC7EUBUlSiZDKTpBgo0VkLhdyiblcLpdUDvxwsLv/tzuze+M4UwhmXjJkH1X6PZEJot0DkjcVYmk3OgYkFSBpqwzZk9TmUJQzg/Y7MEBpRQFuubxoSOo9gNQ9z1sYy5iZ54Hksrs4VCWAAuR0twalMTDeBrK14FQAuVjzYvF4w5DcDy7O50urOm7IPv817pch+zTUnMjuAElz2CJmXssMAJTrEQtPuynSNETzH62Dpi82RYDyHrsrlFYB/cO+IvfVwdYSi5x0dOiAGlCUvM5H9KuDlyAzAEKIzve8o+UwLS8jb05aAHQKeZBomAmA+vD8KjOvzAQAveJ+zBgg7f8F+JqgBp/jA1Bu0wIM2ZuxAYh2K+5nB8PVNIa3nTRRKPjrhuQu0RzlYZ9505kkXNedA7IX8Y/MXmlTcrKGCTpXp2WG+jFozzMbR0ObvkF5Ven3VM2zxC80FhC0ZllxTwAAAABJRU5ErkJggg==)
 */
export const BoostTier3SimpleIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M20.14.8a1.21 1.21 0 0 0-2.28 0l-.5 1.37a2 2 0 0 1-1.19 1.18l-1.38.51a1.21 1.21 0 0 0 0 2.28l1.38.5a2 2 0 0 1 1.18 1.19l.51 1.38c.13.34.37.57.65.7.6.24 1.36.01 1.63-.7l.5-1.38a2 2 0 0 1 1.19-1.18l1.38-.51a1.21 1.21 0 0 0 0-2.28l-1.38-.5a2 2 0 0 1-1.18-1.19L20.14.79Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13.25 1.56c.3.24.23.7-.06.93a3.22 3.22 0 0 0 .9 5.52l1.17.43a.5.5 0 0 1 .3.3l.43 1.16a3.14 3.14 0 0 0 2.51 2.06c.27.04.5.26.5.54V16c0 1.07-.4 2.06-1.05 2.6l-4.9 4c-.65.53-1.45.53-2.1 0l-4.9-4A3.37 3.37 0 0 1 5 16V8c0-1.07.4-2.06 1.05-2.6l4.9-4a1.59 1.59 0 0 1 2.1 0l.2.16Z"
        className={colorClass}
      />
    </svg>
  );
};
